import { baseUrl, headers, jwtFormDataHeaders,  jwtHeaders, logoutUtil } from "../common/data";

export const signup = async (data) => {
    const response = await fetch(`${baseUrl}/admin/signup`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
        redirect: "follow",
    });
    
    if (response?.status === 401) {
        logoutUtil();
    }
    const resData = await response?.json();
    
    return resData;
};

export const login = async (data) => {
    const response = await fetch(`${baseUrl}/api/branch/loginbranch`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
        redirect: "follow",
    });
    if (response?.status === 401) {
        logoutUtil();
    }
    const resData = await response?.json();
    
    return resData;
};
export const googleLogin = async (idToken) => {
  const response = await fetch(`${baseUrl}/api/branch/google-login`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ idToken }),
  });
  const resData = await response?.json();
  if (!response.ok) {
    throw new Error(resData?.message || 'Google login failed');
  }
  return resData;
};

export const forgotpassowrd=async(data)=>{
       const response =await fetch(`${baseUrl}/api/branch/forgotpassword`,{
        method: 'POST',
        headers,
        body: JSON.stringify(data),
        redirect:"follow"
       })
       const resData = await response?.json();
    
       return resData
}

export const getAllUsers = async () => {
    try {
        const response = await fetch(`${baseUrl}/admin/user/all`, {
            headers: jwtHeaders(),
        });
        const resData = await response?.json();
        
        return resData;
    } catch (err) {
        
    }
};

export const OwnerVarification = async (id, data) => {
    const response = await fetch(`${baseUrl}/api/owner/ownervarification/${id}`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers:jwtHeaders()
    });
    const resData = await response.json();
    return resData;
  };
